export default "__VITE_ASSET__5426e735__"